import { render, staticRenderFns } from "./ChargesComponent.vue?vue&type=template&id=824b4f12"
import script from "./ChargesComponent.vue?vue&type=script&lang=js"
export * from "./ChargesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports